import React, { forwardRef } from "react";
import useI18n from "@I18n/hooks/useI18n";
import AppleStoreSvgFr from "./apple-store-fr.svg";
import AppleStoreSvgNl from "./apple-store-nl.svg";
import AppleStoreSvgEn from "./apple-store-en.svg";

const ICONS = {
  fr: AppleStoreSvgFr,
  nl: AppleStoreSvgNl,
  en: AppleStoreSvgEn,
};

// eslint-disable-next-line react/display-name
export const AppleStoreIcon = forwardRef<SVGElement, JSX.IntrinsicAttributes>(
  (props, ref) => {
    const { locale } = useI18n();

    const Svg = ICONS[locale] || ICONS.en;

    return <Svg ref={ref} {...props} />;
  }
);
